module.exports = __webpack_public_path__ + "448c34a56d699c29117adc64c43affeb.woff2";